import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.2592 6.5939c-.3051.2885-.3842.519-.3842.6811s.079.3926.3842.6811c.3067.29.7907.5857 1.451.8499 1.3163.5265 3.1862.869 5.2898.869a.75.75 0 0 1 0 1.5c-2.2455 0-4.3131-.3628-5.847-.9763-.7648-.306-1.4341-.689-1.9244-1.1527-.492-.4652-.8536-1.0634-.8536-1.771s.3616-1.3058.8536-1.771c.4903-.4637 1.1596-.8467 1.9244-1.1527C7.687 3.7378 9.7545 3.375 12 3.375s4.3131.3626 5.8469.976c.7649.306 1.4342.689 1.9246 1.1528.4919.4652.8535 1.0635.8535 1.7712 0 .6681-.3233 1.24-.7732 1.6923-.4469.4493-1.0572.8233-1.7543 1.1268a.75.75 0 0 1-.987-.3882.75.75 0 0 1 .3882-.987c.5923-.258 1.0204-.5388 1.2896-.8094.2663-.2677.3367-.4808.3367-.6345 0-.1624-.0792-.393-.3842-.6814-.3067-.29-.7906-.5857-1.4509-.8498C15.9735 5.2173 14.1036 4.875 12 4.875s-3.9735.3425-5.2899.869c-.6602.2642-1.1442.5599-1.451.8499",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.875 6.5254a.75.75 0 0 1 .75.75v3.6407a.75.75 0 0 1-1.5 0V7.2754a.75.75 0 0 1 .75-.75m-15.75 0a.75.75 0 0 1 .75.75v4.2c0 .2578.223.698 1.0914 1.1811.8238.4583 2.0387.8379 3.5097 1.0464a.7501.7501 0 0 1-.2106 1.4852c-1.5852-.2248-2.9932-.6449-4.0283-1.2208-.9903-.5509-1.8622-1.3791-1.8622-2.4919v-4.2a.75.75 0 0 1 .75-.75",
        clipRule: "evenodd"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.125 10.7246a.75.75 0 0 1 .75.75v4.2c0 .2744.2557.7503 1.2309 1.2561.919.4765 2.2635.8558 3.8663 1.0337a.75.75 0 1 1-.1654 1.4908c-1.7215-.191-3.2593-.6059-4.3914-1.1929-1.076-.558-2.0404-1.4152-2.0404-2.5877v-4.2a.75.75 0 0 1 .75-.75m8.0498 1.4498a4.95 4.95 0 1 1 7.0004 7.0006 4.95 4.95 0 0 1-7.0004-7.0006m3.5002.0502a3.45 3.45 0 1 0 0 6.9 3.45 3.45 0 0 0 0-6.9",
        clipRule: "evenodd"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.9968 13.8531a.75.75 0 0 1 .1501 1.05l-2.0335 2.7118a1.277 1.277 0 0 1-.9302.5067 1.28 1.28 0 0 1-.536-.0773 1.28 1.28 0 0 1-.4556-.2927l-1.0503-1.0503a.75.75 0 0 1 1.0607-1.0607l.8669.8669 1.8779-2.5043a.75.75 0 0 1 1.05-.1501",
        clipRule: "evenodd"
    }, "3")
], "DatabaseCheck", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
